<template>
  <div class="page-404">
    <div class="page-content">
      404页面未找到
    </div>
  </div>
</template>

<script>
export default {
  name: 'page-404'
}
</script>

<style scoped>

</style>
